export const FB_ACCOUNT_SETTINGS = {
  icon: 'mdi-earth',
  iconClass: 'primary white--text',
};

export default [
  {
    id: 'firebase',
    value: 'Firebase',
    icon: 'mdi-firebase',
    iconClass: 'yellow darken-2 white--text',
  },
  {
    id: 'mongodb',
    value: 'Mongo DB',
    icon: 'mdi-database',
    iconClass: 'green accent-3 white--text',
  },
  {
    id: 'heroku',
    value: 'Heroku',
    icon: 'mdi-nodejs',
    iconClass: 'deep-purple darken-1 white--text',
  },
];
